
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 px-6 bg-beige-100/50">
      <div className="max-w-4xl mx-auto">
        <div className="text-left">
          <p className="text-sm text-amber-600 font-medium uppercase tracking-wider mb-4">
            Learn more about what we do
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Need to Paint your House?
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            A fresh new coat of paint makes difference in a room that had been disregarded for a long time. A new coat of paint will also add value to a home that is about to be put on the market. If you have ever tried to change colors in a room or if you have tried to paint a wall and not achieved the desired results, you will be glad to know that we are painters and decorators with the expertise to help you achieve the best paint job your home deserves.
            <br /><br />
            Maintaining the highest level of honesty, professionalism, integrity, and fairness in our relationships with our customers at all times, we are much more than just painters we also do repairs and maintenance of properties, domestic and residential. Please contact for free advice on any project as we offer a fast friendly and very competitive service with no obligation quotes.
          </p>
          <Link
            to="/services"
            className="inline-block px-8 py-4 bg-sky-500 hover:bg-sky-600 text-white font-medium rounded-lg transition-colors duration-300 whitespace-nowrap"
          >
            Get Free Quote
          </Link>
        </div>
      </div>
    </section>
  );
}
